import { RsValue } from '../../../models/base/BaseModel';
import api from '../../axios';

export interface SuggestionRequest {
  type: string;
  message: string;
}

export interface SuggestionResponse {
  id: number;
  type: string;
  message: string;
  userId: string;
}

export const suggestionService = {
  sendSuggestion: (data: SuggestionRequest): Promise<RsValue<SuggestionResponse>> =>
    api.post('/Suggestion', {
      type: data.type,
      message: data.message,
    }),
};
